module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/190/assets/images/b5f6a74c72df3558d640d7465fdfbd95.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_move_arrow.svg
// module id = 87Sf
// module chunks = 1